'use client'

import dynamic from 'next/dynamic'
import Image from 'next/image'
import Link from 'next/link'
import { Grid, Typography } from '@mui/material'

// Types
import type { ContentCardProps } from '@/types/components/molecules/cards/content'

// Helpers
import { useTranslation } from '@/helpers/i18n/client'

// Components
const BrownButtonAtom = dynamic(() => import('@/components/atoms/buttons/brown'))

const ContentCardMolecule = (props: ContentCardProps) => {
	// Props
	const { lng, image, title, description, link } = props

	// Variables
	const { t } = useTranslation(lng)

	return (
		<Grid container direction="row-reverse" justifyContent="space-between" alignItems="center" spacing={2} width={1} mt={22.5}>
			{image && (
				<Grid
					size={{ xs: 12, md: 6.5 }}
					height={{ xs: 320, md: 440 }}
					borderRadius={3.5}
					overflow="hidden"
					sx={{
						'& img': {
							width: 1,
							height: 1,
							objectFit: 'cover',
							filter: 'grayscale(100%)'
						}
					}}
				>
					<Image src={`/api/download${image}`} alt={title ?? ''} width={746} height={440} layout="intrinsic" />
				</Grid>
			)}

			<Grid size={{ xs: 12, md: 5, lg: 4, xl: 3.5 }}>
				<Grid container columns={12} spacing={2}>
					{title && (
						<Grid size={{ xs: 12, md: 8 }}>
							<Typography component="h3" fontSize={26} fontWeight={700} lineHeight={1.25} color="primary.main">
								{title}
							</Typography>
						</Grid>
					)}

					{description && (
						<Grid size={12}>
							<Typography variant="body2" fontWeight={600} lineHeight={1.286}>
								{description}
							</Typography>
						</Grid>
					)}

					{link && (
						<Grid container direction="row-reverse" width={1}>
							<Link href={`/${lng}${link}`}>
								<BrownButtonAtom>{t('form:button.explore')}</BrownButtonAtom>
							</Link>
						</Grid>
					)}
				</Grid>
			</Grid>
		</Grid>
	)
}

export default ContentCardMolecule
